import gsap from 'gsap'
import SplitType from 'split-type'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

/**
 * Wraps the elements of an array.
 * @param {Array} arr - the array of elements to be wrapped
 * @param {String} wrapType - the type of the wrap element ('div', 'span' etc)
 * @param {String} wrapClass - the wrap class(es)
 */

export const wrapLines = (arr, wrapType, wrapClass) => {
  arr.forEach((el) => {
    const wrapEl = document.createElement(wrapType)
    wrapEl.classList = wrapClass
    el.parentNode.appendChild(wrapEl)
    wrapEl.appendChild(el)
  })
}

export function checkForSubmenu(item) {
  const submenu = item.querySelector('.sub-menu')
  if (submenu) {
    item.classList.add('has-sub-menu')
    const menuItems = submenu.querySelectorAll('.menu-item')
    menuItems.forEach((item) => checkForSubmenu(item))
  }
}

/**
 * Animation to highlight text and change the font.
 * @param {Element} el - main element ([data-highlight em])
 * */
export class HighlightText {
  constructor(el, mode) {
    this.el = el

    if (mode == 'auto') {
      this.tl = gsap.timeline({
        paused: true
      })

      setTimeout(() => {
        ScrollTrigger.create({
          trigger: this.el,
          start: 'top center',
          once: true,
          onEnter: () => this.tl.play()
        })
      }, 500)
    } else {
      this.tl = gsap.timeline({
        paused: true
      })
    }

    this.tl.timeScale(1.1)

    setTimeout(() => {
      this.el.style.width = this.el.offsetWidth + 'px'
      this.el.style.height = this.el.offsetHeight + 'px'
    }, 200)

    this.setupAnimation()
  }
  setupAnimation() {
    this.background = document.createElement('div')
    this.split = new SplitType(this.el, { types: 'chars' })
    this.el.appendChild(this.background)
    this.chars = this.el.querySelectorAll('.char')
    this.currentSize = window.getComputedStyle(this.el.parentElement).fontSize.slice(0, -2)
    this.targetSize = window.getComputedStyle(this.el.parentElement).fontSize.slice(0, -2) * 1.2

    this.tl.fromTo(
      this.chars,
      {
        fontSize: this.currentSize + 'px'
      },
      {
        duration: 0.015,
        stagger: 0.05,
        fontFamily: 'Times Now',
        fontStyle: 'italic',
        fontSize: this.targetSize + 'px',
        letterSpacing: '-0.06em',
        ease: 'power4.inOut'
      },
      0.2
    )

    this.tl.to(
      this.background,
      {
        duration: 0.75,
        width: window.innerWidth < 650 ? 'calc(100% + 10px)' : 'calc(100% + 40px)',
        ease: 'power2.inOut'
      },
      0
    )

    this.tl.set(
      this.background,
      {
        left: 'auto',
        right: window.innerWidth < 650 ? '-5px' : '-20px'
      },
      0.75
    )

    this.tl.to(
      this.background,
      {
        duration: 0.75,
        width: 0,
        ease: 'power2.inOut'
      },
      0.76
    )
  }
  play() {
    this.tl.play()
  }
}

export const initHighlightText = () => {
  document.fonts.ready.then(() => {
    const wordsToAnimate = document.querySelectorAll('[data-highlight="auto"] em')
    if (wordsToAnimate.length) wordsToAnimate.forEach((word) => new HighlightText(word, 'auto'))
  })
}

export default () => {}

/**
 * Performs linear interpolation between two numbers.
 * @function
 * @param {number} a - The starting value.
 * @param {number} b - The target value.
 * @param {number} n - Normalization factor, typically between 0 and 1.
 * @returns {number} - Result of the linear interpolation.
 */
export const lerp = (a, b, n) => (1 - n) * a + n * b

/**
 * Calculates the Euclidean distance between two points in a 2D space.
 * @function
 * @param {number} x1 - X-coordinate of the first point.
 * @param {number} y1 - Y-coordinate of the first point.
 * @param {number} x2 - X-coordinate of the second point.
 * @param {number} y2 - Y-coordinate of the second point.
 * @returns {number} - Distance between the two points.
 */
export const distance = (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1)

/**
 * Retrieves the current position from a mouse or touch event.
 * @function
 * @param {Event} ev - The mouse or touch event.
 * @returns {Object} - Object containing the x and y coordinates of the cursor or finger.
 */
export const getPointerPos = (ev) => {
  let posx = 0
  let posy = 0

  // If the event is not provided, use the global window event object.
  if (!ev) ev = window.event

  // Handle touch events
  if (ev.touches) {
    if (ev.touches.length > 0) {
      // Check if there are any touches available
      posx = ev.touches[0].pageX
      posy = ev.touches[0].pageY
    }
  }
  // Handle mouse events
  else if (ev.pageX || ev.pageY) {
    posx = ev.pageX
    posy = ev.pageY
  } else if (ev.clientX || ev.clientY) {
    posx = ev.clientX + body.scrollLeft + docEl.scrollLeft
    posy = ev.clientY + body.scrollTop + docEl.scrollTop
  }

  // Return the position.
  return { x: posx, y: posy }
}

/**
 * Computes the distance between current and last recorded mouse positions.
 * @function
 * @param {Object} mousePos - Current mouse position with x and y coordinates.
 * @param {Object} lastMousePos - Last recorded mouse position with x and y coordinates.
 * @returns {number} - Distance between the two mouse positions.
 */
export const getMouseDistance = (mousePos, lastMousePos) => {
  return distance(mousePos.x, mousePos.y, lastMousePos.x, lastMousePos.y)
}
